import styled from "styled-components";
import { colors } from "../../../styles/tokens";

export const ContainerHoursOfOperation = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0.5vw;

  label {
    color: rgb(255, 255, 255);
    font-weight: bold;

    padding: 0px 16px;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 20px;

    > div:nth-child(1) {
      padding: 4px 16px;
    }
  }
`;

export const ContainerAddress = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5vw;

  > label {
    color: rgb(255, 255, 255);
    font-weight: bold;

    padding: 0px 16px;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  align-items: start;

  gap: 20px;

  height: auto;

  margin-top: 20px;

  > button {
    background: ${colors.gradient};
    background-size: 180% 180%;
    align-items: center;
    border: none;
    border-radius: 100px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    max-width: 245px;
    padding: 1vw;

    color: #fff;

    gap: 10px;
  }
`;

export const ContainerImages = styled.div`
  max-width: 100%;

  > div {
    max-width: 100%;

    width: 160px !important;
  }
`;

export const ContainerTextArea = styled.div``;





export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px; 
  margin: 20px; 
`;

export const Label = styled.span`
  font-size: 16px;
  color: #ffffff;
`;
